import reduce from "image-blob-reduce";
import { toast } from "sonner";

export default function resizeImageFromDataUrl({
  dataUrl,
  maxSize = 1000,
}: {
  dataUrl: string;
  maxSize?: number;
}): Promise<string | undefined> {
  return new Promise(async (resolve, reject) => {
    try {
      const blob = await fetch(dataUrl).then((res) => res.blob());
      const newBlob = await reduce().toBlob(blob, { max: maxSize });

      var a = new FileReader();
      a.onload = function (e) {
        resolve(e.target.result as string);
      };
      a.readAsDataURL(newBlob);
    } catch (e) {
      toast.error("Formát obrázku není podporován.");
      return resolve(undefined);
    }
  });
}
